const getAlerts = (store) => {
  return {
    show: store.root.alertsStore.show || false,
    errorMessage: store.root.alertsStore.errorMessage || '',
  };
};

module.exports = {
  getAlerts,
};
